var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-row',[_c('rkm-col',[_c('rkm-form-textarea',{attrs:{"label":"Mensagem","rows":"4","max-rows":"4","validations":_vm.validations.mensagemProtocolo},model:{value:(_vm.data.model.mensagemProtocolo),callback:function ($$v) {_vm.$set(_vm.data.model, "mensagemProtocolo", $$v)},expression:"data.model.mensagemProtocolo"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }